import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import { useSiteSettings } from "../../context/SiteSettings";
import styles from "./SiteControls.module.scss";

const SiteControls = () => {
  const { language, setLanguage, theme, setTheme, copy } = useSiteSettings();
  const isDark = theme === "dark";

  return (
    <div className={styles.controls} aria-label={copy.controls.language}>
      <div className={styles.languages}>
        {['en', 'fr'].map((item) => (
          <button key={item} type="button" className={language === item ? styles.active : ""} onClick={() => setLanguage(item)} aria-pressed={language === item}>
            {item.toUpperCase()}
          </button>
        ))}
      </div>
      <button type="button" className={styles.theme} onClick={() => setTheme(isDark ? "light" : "dark")} aria-label={isDark ? copy.controls.light : copy.controls.dark} title={copy.controls.theme}>
        {isDark ? <FiSun aria-hidden="true" /> : <FiMoon aria-hidden="true" />}
      </button>
    </div>
  );
};

export default SiteControls;
